import { Container, styled } from "@mui/material";

export const StyledBreadcrumContainer = styled(Container)(({ theme }) => ({
  maxWidth: "xl",
  padding: "0.8rem",
  justifyItems: "center",
  color: "text-primary",
}));
